import gql from 'graphql-tag';

export interface UPSERT_FEEDBACK_SUMMARY_RESULT {
  upsertFeedbackSummary: {
    summary: string;
  };
}

export interface UPSERT_FEEDBACK_SUMMARY_VAR {
  questionId: string;
  eventId: string;
  summary: string;
}

export const UPSERT_FEEDBACK_SUMMARY_MUTATION = gql`
  mutation upsertFeedbackSummary($questionId: String!, $eventId: String!, $summary: String!) {
    upsertFeedbackSummary(
      input: { questionId: $questionId, eventId: $eventId, summary: $summary }
    ) {
      summary
      ok
    }
  }
`;

export interface DELETE_FEEDBACK_SUMMARY_RESULT {
  deleteFeedbackSummary: {
    ok: boolean;
  };
}

export interface DELETE_FEEDBACK_SUMMARY_VAR {
  feedbackSummaryId: string;
}

export const DELETE_FEEDBACK_SUMMARY_MUTATION = gql`
  mutation deleteFeedbackSummary($feedbackSummaryId: String!) {
    deleteFeedbackSummary(feedbackSummaryId: $feedbackSummaryId) {
      ok
    }
  }
`;
